import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="terms-page">
      <SEO
        title="Terms of Use"
        description="Terms of Use for Check On Yo Peoples TV."
        type="website"
      />
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-12 text-gray-300">
        <h1 className="text-4xl sm:text-5xl font-black text-white mb-2">Terms of Use</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: September 2026</p>

        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-bold text-lg mb-2">Use of the site</h2>
            <p>By using coyp.me, you agree to use the site lawfully and not to interfere with its operation, security, or availability.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Content and intellectual property</h2>
            <p>Unless otherwise stated, site content, branding, design elements, and original editorial materials are owned by or licensed to Check On Yo Peoples TV. You may not republish full content for commercial use without permission.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">External links and embeds</h2>
            <p>Stories may link to or embed third-party content. We are not responsible for the availability, policies, or content of third-party websites and services.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">No guarantee of uninterrupted service</h2>
            <p>We work to keep the site available and accurate, but we do not guarantee uninterrupted service, error-free operation, or that every story will remain available at all times.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Changes</h2>
            <p>We may update these terms from time to time. Continued use of the site after updates means you accept the revised terms.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Contact</h2>
            <p>Questions about these terms can be sent to <a href="mailto:contact@coyp.me" className="text-yellow-500 hover:underline">contact@coyp.me</a>.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;